import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'sa-long-escape-tip',
  styleUrls: ['./long-escape-tip.component.scss'],
  templateUrl: './long-escape-tip.component.html',
})
export class LongEscapeTipComponent implements OnInit {
  constructor() {}

  public ngOnInit() {}
}
